define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var fldName = "__RequestVerificationToken";
    var fldSelector = "input[name=\"" + fldName + "\"]";
    function appendAntiforgeryToken($form) {
        var result = $.Deferred();
        if (!$form.find(fldSelector).length) {
            $($(fldSelector)[0]).clone().appendTo($form);
        }
        if (!$form.find(fldSelector).length) {
            console.log('no csrf token');
        }
        result.resolve($form);
        return result.promise();
    }
    exports.appendAntiforgeryToken = appendAntiforgeryToken;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/formUtils.js
// module id = 10
// module chunks = 0